class MFRHitPoints {
  constructor( index, element ) {
      this.$index = index;
      this.$element = $( element );

      this.selectors = {
        slider: '.section-slider',
        point: '.point'
      }

      this.options = {
        wrapAround: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        pageDots: true,
        selectedAttraction: 0.1,
        friction: 0.55,
        cellAlign: "center",
        groupCells: true,
        contain: true
      }

      this.init()
  }

  init() {
    this.slider()
    this.$element.find(this.selectors.point).on('click', this.selectSlide.bind( this ))
  }

  slider() {
    this.$element.find(this.selectors.slider).flickity(this.options)
    this.changeSlide()
    this.sliderDotsWidths()
  }

  selectSlide(event) {
    if ( matchMedia('screen and (max-width: 1024px)').matches ) {
      let currentPoint = event.currentTarget
      let currentPointIndex = Number(event.currentTarget.dataset.index)

      Array.from(this.$element.find(this.selectors.point)).forEach( point => point.classList.remove('is-selected'))
      currentPoint.classList.add('is-selected')

      this.$element.find(this.selectors.slider).flickity('select', currentPointIndex)
    }
  }

  changeSlide() {
    this.$element.find(this.selectors.slider).on( 'change.flickity', ( event, index ) => {
      Array.from(this.$element.find(this.selectors.point)).forEach( point => point.classList.remove('is-selected'))
      this.$element.find(this.selectors.point)[index].classList.add('is-selected')
    })
  }

  sliderDotsWidths() {
    setTimeout(() => {
      const sliderItems = this.$element.find('.flickity-page-dots').children()
      const sliderLength = sliderItems.sliderLength

      Array.from(sliderItems).forEach((slide) => {
        slide.style.width = `calc( ${100 / sliderLength}% - 4px )`
      })

      this.$element.find('.carousel__item').matchHeight()
    }, 1000)
  }
}